<template>
  <div v-if="!copied" class="copy-wrapper" @click.stop="copyText">
    <v-icon v-if="displayIcon" size="16" class="mr-1">mdi-dock-window</v-icon>
    {{ textDisclaimer }}
  </div>
  <div v-else class="copy-wrapper copy-wrapper--copied">
    <v-icon v-if="displayIcon" size="16" class="mr-1">mdi-check-circle</v-icon>Copied!
  </div>
</template>

<script>
  import { useClipboard } from "@vueuse/core";
  export default {
    name: "CopyText",
    props: {
      value: {
        type: String,
        required: true,
      },
      displayIcon: {
        type: Boolean,
        default: false,
      },
      textDisclaimer: {
        type: String,
        default: "Copy",
      },
    },
    data() {
      return {
        copied: false,
      };
    },
    methods: {
      // Only works in secure context
      copyText() {
        const { copy, isSupported } = useClipboard();
        if (window?.isSecureContext && isSupported) {
          copy(this.value);
          this.copied = true;
          setTimeout(() => {
            this.copied = false;
          }, 3000);
        } else {
          this.$admin.toast.error(this.$t("generic.copy_not_supported"));
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/typography/index.scss";
  @import "@core/preset/preset/functions.scss";
  .copy-wrapper {
    @include text-button-small();
    color: get-color("secondary-btn");
    margin-left: 8px;
    white-space: nowrap;
    display: flex;
    &::v-deep {
      .v-icon {
        transition: none;
      }
    }
    i {
      &.v-icon {
        color: get-color("secondary-btn") !important;
      }
    }
    &:hover {
      cursor: pointer;
      color: get-color("same-hover");

      i {
        color: get-color("same-hover");
      }
    }

    &--copied {
      color: get-color("success");
      i {
        color: get-color("success");
      }
      &:hover {
        color: get-color("success");
        cursor: default;

        i {
          color: get-color("success");
        }
      }
    }
  }
</style>
